import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import NavBar from './NavBar'; // Import the NavBar component
import { Card, Row, Col, Container } from "react-bootstrap";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ReportServices = () => {
  const [pdfUrl, setPdfUrl] = useState('./pdfs/stunting.pdf');
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onLoadSuccess = ({ numPages }) => setNumPages(numPages);
  const onError = (err) => console.error('Error loading PDF:', err);

  const handlePrint = () => {
    const printWindow = window.open(pdfUrl, '_blank');
    if (printWindow) {
      printWindow.print();
    }
  };

  return (
    <Container fluid style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <NavBar />
      </div>
      <div style={{ width: "100%", padding: "1rem" }}>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <h3>Reporting Services</h3>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md="12">
                    <div style={{ border: '0px solid #ccc', height: '600px' }}>
                      <Document file={pdfUrl} onLoadSuccess={onLoadSuccess}>
                        <Page pageNumber={pageNumber} />
                      </Document>
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                      <button 
                        onClick={() => setPageNumber(pageNumber - 1)} 
                        disabled={pageNumber <= 1}
                        style={{ marginRight: '5px', padding: '0.5rem 1rem' }}
                      >
                        Previous
                      </button>
                      <button 
                        onClick={() => setPageNumber(pageNumber + 1)} 
                        disabled={pageNumber >= numPages}
                        style={{ marginRight: '5px', padding: '0.5rem 1rem' }}
                      >
                        Next
                      </button>
                      <button 
                        onClick={handlePrint} 
                        style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          padding: '0.5rem 1rem',
                          cursor: 'pointer',
                        }}
                      >
                        Print Out
                      </button>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ReportServices;
